import { CustomEventTypes } from '../../globals';
import store, { StoreActions } from '../../state/store';
import { IModalInfo } from '../../interfaces/Workspace';
import { getUuidv4 } from '../../classes/utilities/Misc';

const modalsMap = new Map<string, IModalInfo>();

// required as a class with separate rendered component since adding functions to react functional components is a nightmare with seriously ugly syntax
export default class ModalManager
{
	/**
	 * Adds any content as a modal window of the application
	 *
	 * @static
	 * @param {IModalInfo} modalInfo
	 * @return {*}  {string} the unique ID of the newly-defined modal
	 * @memberof ModalManager
	 */
	public static addModal(modalInfo: IModalInfo): string
	{
	   const modalId = getUuidv4();
	   modalsMap.set(modalId, modalInfo);
	   store.dispatch(StoreActions.workspace.addModal(modalId));
	   if(modalInfo.disableEvents !== true)
	   {
		   document.dispatchEvent(new CustomEvent(CustomEventTypes.onModalOpened));
	   }
	   return modalId;
	}
   
	/**
	* @param {String} modalId the guid of a modal instance
	* @returns the modalInfo data structure associated with the given modalId
	*/
	public static getModalInfo(modalId: string): IModalInfo | undefined
	{
	   return modalsMap.get(modalId);
	}
      
	/**
	* remove a modal from rendering and its modelInfo data from redux
	* @param {String} modalId the guid of the modal to be removed
	*/
	public static removeModal(modalId: string): void
	{
		const modalInfo:IModalInfo | undefined = ModalManager.getModalInfo(modalId);
		const disableEvents = modalInfo?.disableEvents;
		store.dispatch(StoreActions.workspace.removeModal(modalId));
		modalsMap.delete(modalId);
		if(disableEvents !== true)
		{
			document.dispatchEvent(new CustomEvent(CustomEventTypes.onModalClosed, { detail: { modalIds: [modalId] }}));
		}
	}
   
	/**
	* remove all modals from rendering, and all their modalInfo data structures from redux
	*/
	public static removeAllModals(): void
	{
	   store.dispatch(StoreActions.workspace.clearModals());
	   document.dispatchEvent(new CustomEvent(CustomEventTypes.onModalClosed, { detail: { modalIds: Array.from(modalsMap.keys()) }}));
	   modalsMap.clear();
	}
}